"use client";

import { trackEvent } from "@/lib/trackEvent";

export default function PhoneLink({ children, onClick, onceKey = null, ...props }) {
  const handleClick = (e) => {
    trackEvent("phone_number", 50, onceKey);
    onClick?.(e);
  };

  return (
    <a {...props} onClick={handleClick}>
      {children}
    </a>
  );
}
